/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import FilterTranslated from '../../../components/filter/FilterTranslated';
import FilterStatus from '../../../components/filter/FilterStatus';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemImage, ContentBodyItemStatus, ContentBodyItemPublished,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['name']}>
        <FilterSourceLang />
        <FilterTranslated />
        <FilterStatus />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Image')} width={100} />
          <ContentHeaderItem title={t('Name')} sortBy="name" />
          <ContentHeaderItem title={t('Translations')} width={120} />
          <ContentHeaderItem title={t('Parent')} width={100} />
          <ContentHeaderItem title={t('Creator')} width={100} />
          <ContentHeaderItem title={t('Status')} width={100} />
          <ContentHeaderItem width={100}></ContentHeaderItem>
        </ContentHeader>

        <ContentBody colspan={9}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                <ContentBodyItemImage image={row.logo} />
                <ContentBodyItem to={`/category/${row.id}`}>{row.name}</ContentBodyItem>
                <ContentBodyItemTranslations row={row} editLink="category" />
                {row.parent?.id ? (<ContentBodyItem to={`/category/${row.parent?.id}`}>{row.parent?.name}</ContentBodyItem>) : (<ContentBodyItem />)}
                <ContentBodyItem>{row.creator?.name ?? row.creator?.login ?? ''}</ContentBodyItem>
                <ContentBodyItemStatus row={row} />
                <ContentBodyItemEdit row={row} addLink='categories' editLink='category' deleteLink='categories' />
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'category'} deleteLink={'categories'}>
              <ContentListItem>{row.name}</ContentListItem>
              <ContentListItem>{row.slug}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}